import { render, staticRenderFns } from "./SmplEditEmbrChild.vue?vue&type=template&id=37cadaef&scoped=true&"
import script from "./SmplEditEmbrChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditEmbrChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditEmbrChild.vue?vue&type=style&index=0&id=37cadaef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cadaef",
  null
  
)

export default component.exports